import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function CustomDatePicker({
    id,
    value,
    onChange,
    minDate,
    maxDate,
    className,
}) {
    const selectedDate = value
        ? new Date(`${value}T00:00:00`)
        : null;

    const handleChange = (date) => {
        const formattedDate = date
            ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
            : "";

        onChange(formattedDate);
    };

    return (
        <DatePicker
            id={id}
            selected={selectedDate}
            onChange={handleChange}
            dateFormat="dd/MM/yyyy"
            placeholderText="DD/MM/YYYY"
            minDate={minDate ? new Date(`${minDate}T00:00:00`) : undefined}
            maxDate={maxDate ? new Date(`${maxDate}T00:00:00`) : undefined}
            className={className}
            calendarClassName="geo_datepicker_calendar"
            wrapperClassName="geo_datepicker_wrapper"
            isClearable
        />
    );
}

export default CustomDatePicker;